import { Fragment } from "react";

import { Element } from "@craftjs/core";

import { define, prop } from "@/components/builder/utils";

import { MidpathTCPAAnswerButtonBlock } from "../..";
import BasePreview from "../../base";

function MidpathTCPAAnswerPreview(props) {
  return <>
    <BasePreview {...props}>
      <li className="tcpa-item-answer">
        <Element is={MidpathTCPAAnswerButtonBlock} id="tcpa-answer" />
      </li>
    </BasePreview>
  </>
}

export default define('tcpa-item-answer', MidpathTCPAAnswerPreview, Fragment)
  .shared(prop.share('MidpathTCPAAnswerItem', 'tcpa-item-answer'), { prefix: false })
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    size: { width: "w-50" },
    border: {
      radius: {
        rounded: "sm",
      },
    },
  })
  .build()
